<template>
  <div class="d-flex">
    <div class="video-card box">
      <article class="media">
        <div class="media-left">
          <figure class="image is-128x128">
            <router-link v-if="video.processed" class="thumbnail mr-4" :to="'/videos/' + video.id">
              <img :src="video.thumbnail" alt='video thumbnail'/>
            </router-link>
            <section v-if="!video.processed">
              <h2>Processing...</h2>
              <Loader />
            </section>
          </figure>
        </div>
        <div class="media-content">
          <div class="content">
            <p>
              <strong v-if="shared">{{ video.user.name | video.user.email }}</strong>
              <br>
              <router-link class="vid-link" :to="'/videos/' + video.id">{{ video.title }}</router-link>
              <br>
              <small>{{ video.created_on | prettyTimeStamp }}</small>
            </p>
          </div>
          <nav class="level is-mobile">
            <div class="level-left">
              <a class="level-item">
                <SharedWithUsersIcon v-if="video.is_shared" />
              </a>
              <a class="level-item">
                <span class="icon is-small"><i class="fa fa-retweet"></i></span>
              </a>
              <a class="level-item">
                <span class="icon is-small"><i class="fa fa-heart"></i></span>
              </a>
            </div>
          </nav>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import Loader from './Loader.vue'
import SharedWithUsersIcon from './SharedWithUsersIcon.vue'
import { select } from '../directives.js'

import { prettyTimeStamp } from '../filters.js'

// import store from '../store.js'

export default {
  name: 'VideoCard',
  components: {
    Loader,
    SharedWithUsersIcon,
  },
  directives: {
    select,
  },
  filters: {
    prettyTimeStamp,
  },
  watch: {
    editing (val) {
      // we want to set the initial value of the text input, but we do not want
      // it to possibly be overwritten while editing by the user
      if (val) {
        this.name = this.title
      }
    },
  },
  props: {
    video: {
      required: true,
    },
    shared: {
      type: Boolean,
      required: false,
    },
  },
  data () {
    return {
      editing: false,
      show: false,
      name: '',
      updating: false,
      deleting: false,
      showDelete: false,
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>

img {
  border-radius: 2px;
}

.video-card {
  width: 100%;
}

.vid-link {
  font-size: 1.2rem;
  word-break: break-all;

  @media screen and (min-width: 999px) {
    font-size: 1.5rem;
  }

  @media screen and (min-width: 1192px) {
    font-size: 2.2rem;
    word-break: break-all;
  }

}

</style>



// WEBPACK FOOTER //
// VideoCard.vue?5b870ba2